import React from 'react'

export const BeMessApiContext = React.createContext({ apiContext: null })
